export enum InputEventKey {
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
}

export function isActionKey(key: string): boolean {
  return (
    [
      InputEventKey.ENTER,
      InputEventKey.ESCAPE,
      InputEventKey.ARROW_DOWN,
      InputEventKey.ARROW_UP,
    ] as string[]
  ).includes(key);
}
